import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Auth wrapper
import Auth from '../Auth'

// Actions
import {sendSignup} from '../../actions/signup'
import {setLanguage} from '../../language'

// Components
import Phone from '../../shared/components/Phone'

// import styles
import './signup.scss'

// Utils
import { translation } from '../../utils/helpers'

class Signup extends Component {

  constructor (props) {
    super(props)
    this.state = {
      Name: '',
      Email: '',
      PhoneNumber: '',
      PhoneCode: {Id: 12},
      ShopName: '',
      ShopAddress: '',
      ShopZipCode: '',
      ShopCity: '',
      CountryId: 12,
      AgreeToTerms: false
    }

    let browserLanguage = window.navigator.language || window.navigator.userLanguage

    if (browserLanguage === 'da') {
      this.props.setLanguage('Danish')
    } else {
      this.props.setLanguage('English')
    }

    this.onSubmit = this.onSubmit.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onPhoneChange = this.onPhoneChange.bind(this)
  }

  onSubmit (e) {
    e.preventDefault()
    this.setState({ isLoading: true })

    this.props.sendSignup({
      Name: this.state.Name,
      Email: this.state.Email,
      PhoneNumber: this.state.PhoneNumber,
      PhoneCode: this.state.PhoneCode,
      ShopName: this.state.ShopName,
      ShopAddress: this.state.ShopAddress,
      ShopZipCode: this.state.ShopZipCode,
      ShopCity: this.state.ShopCity,
      CountryId: this.state.CountryId,
      AgreeToTerms: this.state.AgreeToTerms
    }).then(
      (res) => {
        this.props.router.push('/')
      },
      (err) => {
        this.setState({ isLoading: false })
        if (err.response.data !== undefined) {
          let errors = err.response.data
          let errorText = ''
          errors.map((item) => {
            if (item.DictionaryKey !== 0) {
              errorText += '<br />' + translation(item.DictionaryKey)
            }
          })
          // Toastr
          window.toastr.error(translation(errorText), translation('216'))
        } else {
          // Toastr
          window.toastr.error(translation('1883'), translation('216'))
        }
      })
  }

  onChange (e) {
    let value = e.target.value
    if (e.target.type === 'checkbox') {
      value = e.target.checked
    }
    this.setState({ [e.target.name]: value })
  }

  onPhoneChange (name, e) {
    let value = ''
    value = name.target.value
    if (name.target.name === 'PhoneNumber') {
      name = 'PhoneNumber'
      this.setState({
        [name]: value
      })
    } else {
      this.setState({
        PhoneCode: {
          Id: Number(value)
        }
      })
    }
  }

  render () {
    const { isLoading } = this.state

    return (
      <Auth>
        <div className='signup__screen clearfix'>
          <div className='main__left'>
            <h2>{translation('2120')}</h2>
            <p>{translation('2121')}</p>
            <p>{translation('2122')} <a className='green' href='https://apromas.com'>{translation('2123')}</a></p>
          </div>
          <div className='main__right'>
            <form onSubmit={this.onSubmit}>
              <h2>{translation('2119')}</h2>

              <div className='control__group'>
                <input type='text' name='Name' onChange={this.onChange} placeholder={translation('30')} autoComplete='off' />
              </div>

              <div className='control__group'>
                <input type='text' name='Email' onChange={this.onChange} placeholder={translation('1052')} autoComplete='off' />
              </div>

              <div className='control__group'>
                <Phone
                  onChange={this.onPhoneChange}
                  code={this.state.PhoneCode}
                  number={this.state.PhoneNumber} />
              </div>

              <div className='control__group'>
                <input type='text' name='ShopName' onChange={this.onChange} placeholder={translation('2116')} autoComplete='off' />
              </div>

              <div className='control__group'>
                <input type='text' name='ShopAddress' onChange={this.onChange} placeholder={translation('25')} autoComplete='off' />
              </div>

              <div className='control__group'>
                <input type='text' name='ShopZipCode' onChange={this.onChange} placeholder={translation('40')} autoComplete='off' />
              </div>

              <div className='control__group'>
                <input type='text' name='ShopCity' onChange={this.onChange} placeholder={translation('37')} autoComplete='off' />
              </div>

              <div className='control__group'>
                <select value={this.state.CountryId} onChange={this.onChange} name='CountryId'>
                  {this.props.countries.map((val, index) => {
                    let showVal = translation(val['CountryName'])
                    return <option value={val['Id'].toString()} key={index}>{showVal}</option>
                  })}
                </select>
              </div>

              <div className='checkbox__custom__wrapper'>
                <div className='checkbox__custom'>
                  <input type='checkbox' id='terms' name='AgreeToTerms' value='1' checked={this.state.AgreeToTerms} onChange={this.onChange} />
                  <label htmlFor='terms'><span>{translation('2127')} <a>{translation('2128')}</a></span></label>
                </div>
              </div>

              <button disabled={isLoading} className='button'>{translation('2115')}</button>
            </form>
          </div>
        </div>
      </Auth>
    )
  }

}

Signup.propTypes = {
  setLanguage: PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    phonecode: state.common.phonecode,
    phonecodes: state.common.phonecodes,
    countries: state.common.countries
  }
}

export default connect(mapStateToProps, {sendSignup, setLanguage})(Signup)



// WEBPACK FOOTER //
// ./src/app/pages/Signup/index.js